import { atom, selector } from "recoil";
import GlobalsService from "src/services/auth/globals";

export const codeAreasState = atom({
    key: 'codeAreas',
    default: []
})

export const codeAreasFetchState = selector({
    key: 'codeAreasFetch',
    get: async () => {
        const { data } = await GlobalsService.getCodeArea();

        return data.data;
    }
});

export const covenantsBaseState = atom({
    key: 'covenantsBase',
    default: []
})

export const covenantsBaseFetchState = selector({
    key: 'covenantsBaseFetch',
    get: async () => {
        const { data } = await GlobalsService.getCovenantsBase();

        return data.data;
    }
});

export const generosBaseState = atom({
    key: 'generosBase',
    default: []
})

export const generosBaseFetchState = selector({
    key: 'generosBaseFetch',
    get: async () => {
        const { data } = await GlobalsService.getGenerosBase();

        return data.data;
    }
});

export const confirmAccountState = atom({
    key: 'confirmAccount',
    default: {
        code1: null,
        code2: null,
        code3: null,
        code4: null,
        code5: null,
        code6: null,
    }
})

export const errorsConfirmAccountState = atom({
    key: 'errorsConfirmAccount',
    default: {
        confirmAccountErrors: []
    }
})